import type { Breadcrumb } from '@sentry/react'

const ATTENDEE_EMAIL_PATH = /(\/registration\/events\/[^/?#\s]+\/attendees\/)(?!counts-by-region(?:[/?#\s]|$))[^/?#\s]+/
const REDACTED = '$1[redacted]'
const TOKEN_DELIMITERS = /([\s"'<>()[\]]+)/

function isEmail(token: string): boolean {
  const at = token.indexOf('@')
  const lastDot = token.lastIndexOf('.')
  return at > 0 && lastDot > at + 1 && lastDot < token.length - 1
}

function redactEmails(text: string): string {
  return text
    .split(TOKEN_DELIMITERS)
    .map((token) => (isEmail(token) ? '[redacted]' : token))
    .join('')
}

export default function redactSentryBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
  const redacted: Breadcrumb = { ...breadcrumb }

  if (typeof redacted.message === 'string') {
    const withoutEmailPath = redacted.message.replace(ATTENDEE_EMAIL_PATH, REDACTED)
    redacted.message = redactEmails(withoutEmailPath)
  }

  if (typeof redacted.data?.url === 'string') {
    redacted.data = { ...redacted.data, url: redacted.data.url.replace(ATTENDEE_EMAIL_PATH, REDACTED) }
  }

  return redacted
}
